import { render, staticRenderFns } from "./OssUpload.vue?vue&type=template&id=bc7e1fde&scoped=true"
import script from "./OssUpload.vue?vue&type=script&lang=js"
export * from "./OssUpload.vue?vue&type=script&lang=js"
import style0 from "./OssUpload.vue?vue&type=style&index=0&id=bc7e1fde&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7e1fde",
  null
  
)

export default component.exports